import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isString, isUnknownObject } from '~/shared/utils/guards'
import type { ResumeDictionaryItem } from '~/types/unified-profile'

export default class UnifiedProfileExperienceEntry extends BaseModel {
  static override constructorName = 'UnifiedProfileExperienceEntryModel'

  id: number | null = null
  'resume_id': number | null = null
  'job_facility': string = ''
  'start_date': string | null = null
  'end_date': string | null = null
  'job_desc': string | null = null
  'for_now': boolean = false
  internship: boolean = false
  'position_id': number | null = null
  position: string | null = null
  'desired_position_dictionary': ResumeDictionaryItem[] = []

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)

      if (!isString(this.job_facility)) {
        this.job_facility = ''
      }
    }
  }
}

registerModel(UnifiedProfileExperienceEntry)
